import { maskitoTransform } from '@maskito/core';
import { maskitoPhoneOptionsGenerator } from '@maskito/phone';
import metadata from 'libphonenumber-js/min/metadata';
const ANY_COUNTRY_PHONE_MASK = maskitoPhoneOptionsGenerator({ metadata, strict: false });
const maskPhone = (value) => maskitoTransform(value, ANY_COUNTRY_PHONE_MASK);
export { ANY_COUNTRY_PHONE_MASK, maskPhone };
